import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios from 'axios';
import _cloneDeep from 'lodash/cloneDeep';
import { getRequestError, normalizeError } from './_helpers';

var requestInterceptor = function requestInterceptor(config) {
  var _config = _cloneDeep(config);

  var headers = config.headers || {};
  var authToken = null;

  if (_config.authToken) {
    authToken = _config.authToken;
    delete _config.auth;
  }

  if (authToken && typeof authToken === 'function') {
    authToken = authToken();
  }

  if (authToken) {
    headers['Authorization'] = "Bearer ".concat(authToken);
  }

  var lang = _config.lang;

  if (lang && typeof lang === 'function') {
    lang = lang();
  }

  if (lang) {
    headers['-Language'] = lang;
  }

  delete _config.lang;
  return Object.assign(_config, {
    headers: headers
  });
};

var responseInterceptor = [function (xhr) {
  var _response$data;

  var response = xhr.data || {};

  if (!xhr) {
    return null;
  }

  if (xhr.status !== 204 && !response.success) {
    return Promise.reject(normalizeError(response.error, xhr.status));
  }

  return _objectSpread(_objectSpread({}, xhr), {}, {
    data: (_response$data = response.data) !== null && _response$data !== void 0 ? _response$data : null
  });
}, function (err) {
  if (axios.isCancel(err)) {
    return Promise.reject({
      isCanceled: true
    });
  }

  var error;

  if (err.response) {
    var response = err.response || {};
    error = normalizeError(response.data, response.status);
  } else {
    error = getRequestError(err);
  }

  return Promise.reject(error);
}];
export default {
  request: requestInterceptor,
  response: responseInterceptor
};